import { useSelectedEntity } from "@fero/hooks";

export function useSelectedEntityIsWholesaler(): boolean {
  const selectedEntity = useSelectedEntity();
  return selectedEntity.type === "org"
    ? selectedEntity.value.value.facilitySegment === "Wholesaler"
    : false;
}
